import { LocalizedStrict } from "../../../../../modules/localization/components/AppLocalized"
import { useExternalLinks } from "../../../../hooks/useAppLinks"
import { TrainingGuideCard } from "./TrainingGuideCard"
import { HelpSection } from "./HelpSection"

export const TrainingGuides = () => {
    const handleExternalLink = useExternalLinks()

    return (
        <LocalizedStrict id="help-dialog-training" attrs={{ title: true }}>
            <HelpSection title="Training">
                <LocalizedStrict id="help-dialog-training-education-center" attrs={{ title: true, description: true }}>
                    <TrainingGuideCard
                        title="Education Center"
                        description="In the Education Center you can view Get Started guides and other training material."
                        handleCardClick={() => handleExternalLink("https://gopay.menu/education-center")}
                    />
                </LocalizedStrict>
            </HelpSection>
        </LocalizedStrict>
    )
}
